import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const EndlessBookIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M7 13H5v-1h2zm2-3.5v1H5v-1zM9 8H5V7h4z" /><path fillRule="evenodd" clipRule="evenodd" d="M8 2a5 5 0 0 1 4 2 5 5 0 0 1 4-2h5a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2h-6a2 2 0 0 0-2 2 1 1 0 1 1-2 0 2 2 0 0 0-2-2H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zM3 17h6a4 4 0 0 1 2 .54V7a3 3 0 0 0-3-3H3zM16 4a3 3 0 0 0-3 3v10.54a4 4 0 0 1 2-.54h6V4z" />
    </SvgIcon>
);
